<template>
  <section>
      <header>
          <div class="flex">
          <!-- <div class="container1">
           <h3 >BENEFITS OF YOGA FOR EARLY BEGINNERS</h3>
           </div> -->
           <div class="proud">
           <h1>
         Proud member of lil yogi club
      </h1>
      <img src="../../assets/benefits.png" alt="">
      <h1>Our special programmes</h1>
      </div>
      <div class="container3">
      <h1 class="benefits">Benefits of yoga</h1>
      </div>
      <div class="container4">
      <img  src="../../assets/underline.png" alt="">
      </div>
      </div>
      <div class="cards">
      <div class="card1">
          <img src="../../assets/benefits1.png" alt="">
          <h2>Focus</h2>
          <!-- <h4>We offer transformative online <br> and offline yoga classes for kids, <br> aged three to fifteen. </h4> -->
      </div>
      <div class="card1">
          <img src="../../assets/benefits2.png" alt="">
          <h2>Strength</h2>
          <!-- <h4>We offer transformative online <br> and offline yoga classes for kids, <br> aged three to fifteen. </h4> -->
      </div>
      <div class="card1">
          <img src="../../assets/benefits3.png" alt="">
          <h2>Flexibility</h2>
          <!-- <h4>We offer transformative online <br> and offline yoga classes for kids, <br> aged three to fifteen. </h4> -->
      </div>
      <div class="card1">
          <img src="../../assets/benefits4.png" alt="">
          <h2>Independence</h2>
          <!-- <h4>We offer transformative online <br> and offline yoga classes for kids, <br> aged three to fifteen. </h4> -->
      </div>
      </div>
      <h1 class="empathy">
         Value Education . Skill - Building . Discipline . Self-Awareness. Peace. Energy
      </h1>
      </header>
  </section>
</template>

<script>
export default {

}
</script>

<style scoped>
.empathy{
    font-size: 3rem;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
    color: #4BA3C3;
        margin-top: 170px;
        text-align: center;
}
.cards{
    display: flex;
    align-items: center;
    width: 80%;
    margin: auto;
    justify-content: space-around;
    text-align: center;
    padding-top: 83px;
    flex-wrap: wrap;
}

.flex{
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 331px;
    justify-content: space-evenly;
    /* margin-top: 150px; */
}
.proud{
    display: flex;
    width: 80%;
    margin: auto;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
}
h3{
    color: #791E94;
    font-weight: 450;
}
h1{
    font-size: 3rem;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
    color: #4BA3C3;
}
.benefits{
    font-size: 3rem;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
    color: #791E94;
}
h2{
     color: #791E94;
    font-weight: 400;
    /* font-size: 3rem; */
    font-family: Original Surfer;
}
h4{
    color: #445268;
    font-weight: 500;
    line-height: 200%;
    padding-bottom: 34px;
}


@media (max-width: 1080px){
    .proud{
        justify-content: center;
        align-items: center;
        text-align: center;
    }
    .cards{
            height: 1220px;
    }
    .flex{
            height: 588px;
    }
}
</style>